import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './redux';
import { PlayerTable } from './component';


export default connect(mapStateToProps, mapDispatchToProps)(PlayerTable);
